import {
    DoughnutChart,
    DoughnutChartSeriesItem,
} from 'utils/components/DoughnutChart/DoughnutChart';
import React, { PropsWithChildren } from 'react';
import styleConstants from '../variables.module.scss';
import { getSideClass } from 'utils/css/cssUtils';
import { OrderSide } from 'communication/types/order/OrderSide';
import {
    filledWidth,
    exposedWidth,
} from 'widgets/openSubmissions/doughnut/openSubmissionsDoughnutChartSeries';
import classNames from 'classnames';

const scale = 2;
const doughnutSize = parseInt(styleConstants.doughnutSize) / scale;

type OpenSubmissionsDoughnutChartHelpProps = PropsWithChildren<{
    side?: OrderSide;
    emphasiseFilled?: boolean;
    emphasiseExposed?: boolean;
}>;

export default function OpenSubmissionsDoughnutChartHelp(
    props: OpenSubmissionsDoughnutChartHelpProps
) {
    const { side, emphasiseFilled, emphasiseExposed, children } = props;
    const data: DoughnutChartSeriesItem[] = [
        {
            value: 4,
            segmentWidth: filledWidth / scale,
            classname: classNames(
                'filled',
                getSideClass(side || 'B'),
                emphasiseFilled && 'emphasised'
            ),
            id: 'filled',
        },
        {
            value: 1,
            segmentWidth: exposedWidth / scale,
            classname: classNames(
                'litOrExchange',
                emphasiseExposed && 'emphasised'
            ),
            id: 'litOrExchange',
        },
        {
            value: 2,
            segmentWidth: exposedWidth / scale,
            classname: classNames('dark', emphasiseExposed && 'emphasised'),
            id: 'dark',
        },
        {
            value: 5,
            segmentWidth: 1,
            classname: 'remaining',
            id: 'remaining',
        },
    ];
    return (
        <DoughnutChart
            doughnutSize={doughnutSize}
            data={data}
            className="OpenSubmissionsDoughnutChartHelp"
        >
            {children}
        </DoughnutChart>
    );
}
